export const checkOtherOption = (state, action) => {
    const inputName = action.inputName;
    return {
        ...state.other_options,
        [inputName]: {
            ...state.other_options[inputName],
            checked: action.checked
        }
    }

};